import { z } from 'zod';
import { idArray } from './shared.schema';

const filterSchema = z.discriminatedUnion('type', [
	z.object({
		type: z.literal('accountId'),
		value: z.number().int(),
	}),
	z.object({
		type: z.literal('subscriptionName'),
		value: z.string().trim().min(1),
	}),
	z.object({
		type: z.literal('invoiceId'),
		value: z.string().trim().min(1),
	}),
	z.object({
		type: z.literal('creditId'),
		value: z.string().trim().min(1),
	}),
]);

export const transactionParametersSchema = z.strictObject({
	startDate: z.iso.date(),
	endDate: z.iso.date().optional(),
	filter: filterSchema.optional(),
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
});

export type TransactionParameters = z.infer<typeof transactionParametersSchema>;
